import {
  DELETE_PLANT_FAILURE,
  DELETE_PLANT_SUCCESS,
  ON_DELETE_PROMPT_MODAL,
  ON_TOGGLE_DELETE_MODAL,
} from './actions';

const initialState = {
  deleteMessage: '',
  deletePromptModal: false,
  feilds: {
    name: ''
  },
  plantIdToDelete: null
};

function CardItemReducer(state = initialState, actions) {
  switch(actions.type) {
      case DELETE_PLANT_SUCCESS: {
        const deleteMessage = actions.payload.message;
        return {
          ...state,
          deleteMessage,
        };
      }
      case DELETE_PLANT_FAILURE: {
        return {
          ...state,
          error: actions.error
        };
      }
      case ON_DELETE_PROMPT_MODAL: {
        return {
          ...state,
          deletePromptModal: actions.isActive,
          plantIdToDelete: actions.plantIdToDelete,
        };
      }
      case ON_TOGGLE_DELETE_MODAL: {
        return {
          ...state,
          deletePromptModal: actions.isActive,
          plantIdToDelete: null
        }
      }
    default:
      return { ...state };
  }
}

export default CardItemReducer;
